import { render } from "./InstallPWA.vue?vue&type=template&id=14a4ef0b"
import script from "./InstallPWA.vue?vue&type=script&lang=js"
export * from "./InstallPWA.vue?vue&type=script&lang=js"

import "./InstallPWA.vue?vue&type=style&index=0&id=14a4ef0b&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__